<div class="modal-header">
  <h5 class="modal-title">{{'LABEL.CONFIG' | translate}}
  </h5>
  <button (click)="closeModal()" class="close">
    <svg class="icon">
      <use xlink:href="assets/svg/sprite.svg#it-close"></use>
    </svg>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="configForm">
    <ul class="nav nav-tabs" id="confList" role="tablist">
      <!--                              tab settings-->
      <li class="nav-item"><a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab"
                              aria-controls="tab1" aria-selected="true">{{'CONFIG.LAYOUT' | translate}}</a></li>
    </ul>
    <!--        tab content settings-->
    <div class="tab-content" id="confContent">
      <!--          layout setting-->
      <div class="tab-pane p-4 fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
        <app-setting-layout [configForm]="configForm"></app-setting-layout>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="closeModal()" class="btn btn-outline-secondary btn-sm" type="button">
    {{'BUTTON.CLOSE'|translate}}
  </button>
  <button (click)="onSaveSetting()" [disabled]="!configForm?.dirty || !configForm?.valid"
          class="btn btn-primary btn-sm"
          type="button">
    {{'BUTTON.CONFIRM'|translate}}
    <span *ngIf="configForm?.pending || submitLoading" class="spinner-border spinner-border-sm" role="status"
          aria-hidden="true"></span>
  </button>
</div>

